// Under Module Federation the webclient's shared modules are reused on CPIP re-entry, so their
// style-loader CSS never re-injects. Track the tags while present, re-attach the missing ones on return.
type StyleStash = { __CPIP_PERSISTED_STYLES__?: Set<HTMLStyleElement> };
const stash = () => {
  const w = window as Window & StyleStash;
  return (w.__CPIP_PERSISTED_STYLES__ ??= new Set<HTMLStyleElement>());
};

// emotion + makeStyles regenerate themselves, and the MFE *-app-styles tags are never torn down.
const selfHeals = (el: HTMLStyleElement) => {
  const name = el.getAttribute("name") || "";
  return el.hasAttribute("data-emotion") || el.hasAttribute("data-meta") || (/-app-styles$/.test(name) && name !== "ci-app-styles");
};

let observer: MutationObserver | undefined;

export function trackStyles() {
  const capture = () =>
    document.head.querySelectorAll("style").forEach((el) => {
      if (!selfHeals(el)) stash().add(el);
    });
  capture();
  observer?.disconnect();
  observer = new MutationObserver(capture);
  observer.observe(document.head, { childList: true });
}

export function stopTracking() {
  observer?.disconnect();
}

export function restoreStyles() {
  const present = new Set([...document.head.querySelectorAll("style")].map((el) => el.textContent));
  // p81styles must sit before the MFE *-app-styles tags (badge text-transform cascade).
  const mfeAnchor = document.head.querySelector('style[name="network-app-styles"], style[name="ia-app-styles"]');
  stash().forEach((el) => {
    if (el.isConnected || present.has(el.textContent)) return;
    if (el.getAttribute("name") === "p81styles" && mfeAnchor) document.head.insertBefore(el, mfeAnchor);
    else document.head.appendChild(el);
    present.add(el.textContent);
  });
}
